import { Component, EventEmitter, Input, Output } from '@angular/core';
import { rentUnitSizeWiseConstant } from './rent-unit-size-wise.constant';
import { SharedService } from 'src/app/common/services/shared.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { rentUnitSizeWisePropertyDetailService } from './rent-unit-size-wise.service';
import { PropertyCategoryEnum } from '../../../propertyCategory.enum';

@Component({
  selector: 'app-rent-unit-size-wise',
  templateUrl: './rent-unit-size-wise.component.html',
  styleUrls: ['./rent-unit-size-wise.component.scss']
})
export class RentUnitSizeWiseComponent {
  @Input() report_category = '';
  @Input() tableType = '';
  @Input() tableHeading !: string;
  @Input() propertyInfo !: any;
  downloadLoading : boolean = false
  rentUnitSizeTableData: any = [];
  rentUnitSizeWiseLoading: boolean = false;
  rentUnitSizeWiseCount: number = 0;
  userInfo: any = 0;
  placeCode: string = '';
  tableName: unknown = '';
  rentUnitSizeWiseColumn = rentUnitSizeWiseConstant.rentUnitSizeWiseTableColumn;
  rentunitSizeDropDown = rentUnitSizeWiseConstant.rentUnitSizeDropdown;
  propertyCategory = PropertyCategoryEnum;
  @Output() retailRentSection: EventEmitter<boolean> = new EventEmitter<boolean>();
  isFirstTime = true;
  constructor(
    private sharedService: SharedService,
    private alertService: AlertService,
    private translate: TranslateService,
    public reportService: ReportService,
    public rentUnitSizeService: rentUnitSizeWisePropertyDetailService,
  ) {
this.sharedService.language$.subscribe(lang => {
      if (lang && !this.isFirstTime) {
        this.getRentUnitSizeWise();
      }
    })
  }
  
  ngOnChanges() {
    this.getRentUnitSizeWise();
  }

  ngOnInit() {
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.getRentUnitSizeWise();
    this.isFirstTime = false;
  }

  getRentUnitSizeWise() {
    this.rentUnitSizeWiseLoading = true;
    const payload = this.tableType === 'officeRent' ? this.rentUnitSizeService.officeRentPayload : this.rentUnitSizeService.retailRentPayload;
    this.rentUnitSizeService.getRentUnitSizeWise(payload, this.propertyInfo?.property_uid, this.tableType).subscribe(
      {
        next: (res: any) => {
          this.rentUnitSizeWiseLoading = false;
          if (res.status === 200) {
            this.rentUnitSizeTableData = res.data;
            if (payload.pageNumber == 0) {
              this.rentUnitSizeWiseCount = res.count;
            }
            if(this.report_category == this.propertyCategory.MultiStoryOffice && this.tableType === 'retailRent'){
              this.rentUnitSizeTableData?.length > 0 ? this.retailRentSection.emit(true) : this.retailRentSection.emit(false);
            }
            if(this.report_category == this.propertyCategory.RetailFbAndEntertainment && this.tableType === 'officeRent') {
              this.rentUnitSizeTableData?.length > 0 ? this.retailRentSection.emit(true) : this.retailRentSection.emit(false);
            }
          } else {
            this.rentUnitSizeTableData = [];
            this.rentUnitSizeWiseCount = 0;
            if(this.report_category == this.propertyCategory.MultiStoryOffice && this.tableType === 'retailRent') this.retailRentSection.emit(false);
            if(this.report_category == this.propertyCategory.RetailFbAndEntertainment && this.tableType === 'officeRent') this.retailRentSection.emit(false);
              
            
          }
        },
        error: () => {
          this.rentUnitSizeWiseLoading = false;
          this.rentUnitSizeTableData = [];
          this.rentUnitSizeWiseCount = 0;
          if(this.report_category == this.propertyCategory.MultiStoryOffice && this.tableType === 'retailRent') this.retailRentSection.emit(false);
          if(this.report_category == this.propertyCategory.RetailFbAndEntertainment && this.tableType === 'officeRent') this.retailRentSection.emit(false);
        }
      }
    )
  }

  onPageEvent(e: any) {
    if(this.tableType === 'officeRent'){
      this.rentUnitSizeService.officeRentPayload.pageNumber = (e.pageSize * e.pageIndex);
    }else{
      this.rentUnitSizeService.retailRentPayload.pageNumber = (e.pageSize * e.pageIndex);
    }
    this.getRentUnitSizeWise();
  }
  sortData(event: any) {
    let sort = {
      column: event.active,
      order: event.direction,
    };
    if(this.tableType === 'officeRent'){
      this.rentUnitSizeService.officeRentPayload.pageNumber = 0;
      this.rentUnitSizeService.officeRentPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    }else{
      this.rentUnitSizeService.retailRentPayload.pageNumber = 0;
      this.rentUnitSizeService.retailRentPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    }
    this.getRentUnitSizeWise();
  }
  dropDownChange(value: any) {
    if (value === 'Range') {
      this.rentUnitSizeWiseColumn = rentUnitSizeWiseConstant.rentUnitSizeWiseTableColumn;
    } else {
      this.rentUnitSizeWiseColumn = rentUnitSizeWiseConstant.rentUnitSizeWiseTableColumnAvg;
    }
  }
  lastClickedTable(event: Event, table: any) {
    this.tableName = table;
  }
  downloadExcel() {
    let type = "property_detail_retail_unit_size";
    if(this.tableType === 'officeRent') type = "property_detail_office_unit_size";
    this.downloadRentalReport(type);
  }

  downloadRentalReport(type: string) {
    this.downloadLoading = true
    this.reportService.downloadReport(type, this.userInfo?.user_id, "", this.propertyInfo?.property_uid, true).subscribe({
      next: (res: any) => {
        this.downloadLoading = false;
        if (res.status === 200) {
          const downloadUrl = `${this.sharedService.downloadExcelPath()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=unit_rental`;
          this.sharedService.downloadExcelUrl(downloadUrl);
          this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));
        } else {
          this.alertService.warn(res.message);
        }
      },
      error: (error: any) => { 
         this.downloadLoading = false;
      },
    });
  }
}
